import { ELIGIBILITY_APPLICATION_KEY } from '@/constants/treatmentGroups';
import { useLogicApplication } from '@/hooks/useLogicApplication';
import { useLogicGroups } from '@/hooks/useLogicGroups';
import useMemberEligibilityCheck from '@/hooks/useMemberEligibilityCheck';
import { toEligibilityPayload } from '@/utils/eligibilityPayload';

// Re-checks a saved group's members/session staff against its own saved
// eligibility tree -- the read-only counterpart to TreatmentGroupForm's live
// check against an in-progress tree, so read-only views can show the same
// eligibility badges the edit form shows.
const useTreatmentGroupMemberEligibility = ({
  appointmentTypeId,
  personIds,
  staffIds,
  treatmentGroupId
}: {
  appointmentTypeId: string;
  personIds: string[];
  staffIds: string[];
  treatmentGroupId?: string;
}) => {
  const { data: eligibilityApplication } = useLogicApplication(ELIGIBILITY_APPLICATION_KEY);
  const { data: rootGroups } = useLogicGroups(eligibilityApplication?.id, treatmentGroupId);

  return useMemberEligibilityCheck({
    appointmentTypeId,
    eligibility: toEligibilityPayload(rootGroups ?? []),
    personIds,
    staffIds
  });
};

export default useTreatmentGroupMemberEligibility;
